import { ColumnDef } from "@tanstack/react-table";

// Type definitions
interface DisciplinaryTypeRow {
	id: number;
	name: string;
	description: string;
	code: string;
	createdAt?: string;
	modifiedAt?: string;
}

// ========== Disciplinary Type Columns ==========
export const disciplinaryColumns: ColumnDef<DisciplinaryTypeRow>[] = [
	{
		id: "name",
		accessorKey: "name",
		header: "Name",
		size: 200,
	},
	{
		id: "description",
		accessorKey: "description",
		header: "Description",
		size: 380,
	},
	{
		id: "code",
		accessorKey: "code",
		header: "Code",
		size: 180,
	},
];

export const disciplinaryColumnVisibility: Record<string, boolean> = {
	name: true,
	description: true,
	code: true,
};
